import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { formatPrice } from 'utils/numberFormatter';
import { CustomItem } from '../../../../../models/quotations/Quotation';
import { TableCellWrapper } from 'components/quotation-editor/shared/TableCellWrapper';
import { styled } from '@mui/material';
import { StyledTableCellWrapper } from '../QuotationSummaryProducts';

const StyledCustomItemRow = styled(TableRow)(() => ({
    '&:not(.last-item)': {
        td: {
            borderBottom: 'none !important',
        },
    },
}));

export const QuoSumProdCustomItemsRow: React.FC<{
    custom_items: CustomItem[];
}> = (props) => {
    const { custom_items } = props;

    return (
        <>
            {custom_items.map((rowCustomItem, index) => (
                <StyledCustomItemRow
                    hover
                    key={index}
                    className={
                        custom_items.length - 1 == index ? 'last-item' : ''
                    }
                >
                    <StyledTableCellWrapper type={'name'}>
                        {rowCustomItem.name}
                    </StyledTableCellWrapper>
                    <StyledTableCellWrapper>
                        {`${rowCustomItem.quantity} ${rowCustomItem.unit}`}
                    </StyledTableCellWrapper>
                    <StyledTableCellWrapper>
                        {formatPrice(rowCustomItem.net_price)}&nbsp;Ft
                    </StyledTableCellWrapper>
                    <StyledTableCellWrapper></StyledTableCellWrapper>
                    <StyledTableCellWrapper>
                        {formatPrice(
                            rowCustomItem.net_price * rowCustomItem.quantity
                        )}
                        &nbsp;Ft
                    </StyledTableCellWrapper>
                    <StyledTableCellWrapper>
                        {rowCustomItem.tax}&nbsp;%
                    </StyledTableCellWrapper>
                    <StyledTableCellWrapper>
                        {formatPrice(
                            rowCustomItem.net_price *
                                (rowCustomItem.tax / 100 + 1) *
                                rowCustomItem.quantity
                        )}
                        &nbsp;Ft
                    </StyledTableCellWrapper>
                </StyledCustomItemRow>
            ))}
        </>
    );
};
